export const getSponsorBannerUrl = business =>
  business?.banner_ad_graphics?.direct_upload_url ??
  business?.banner_ad_graphics?.thumbnail_url ??
  null

export default {
  getSponsorBannerUrl,
}
